import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import Select from "react-select";
import "./Ips.css";
import { UpdateIpStatus } from "../../../config/LiveApi";
import { toast } from "react-toastify";

const UpdateModal = ({ isOpen, onClose, ipData, token, onUpdate }) => {
  const [status, setStatus] = useState(ipData?.ipStatus);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await UpdateIpStatus(token, ipData.id, status); 
      onUpdate(ipData.id, status); 
      toast.success("IPs Status Update successfully")
      onClose();
    } catch (error) {
      toast.error("Error updating IP status")
      console.error("Error updating IP status:", error);
    }
  };

  const statusOptions = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
    { value: "blocked", label: "Block" },
  ];

  return (
    <div className="ips-modal-overlay">
      <div className="ips-modal-content">
        <button onClick={onClose} className="ips-modal-buttons-close">
          <FaTimes size={25} />
        </button>
        <h2>Update IP Status</h2>
        <form onSubmit={handleSubmit}>
          <label htmlFor="ip">IP Address:</label>
          <input type="text" value={ipData?.ip || ""} readOnly />

          <label htmlFor="status">Status:</label>
          <Select
            options={statusOptions}
            value={statusOptions.find((opt) => opt.value === status)}
            onChange={(selectedOption) => setStatus(selectedOption.value)}
          />

          <button className="ips-modal-buttons" type="submit">Update</button>
        </form>
      </div>
    </div>
  );
};

export default UpdateModal;
